import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const DetailsContainer = styled.div`
  padding: 1rem;
  background-color: #f0f4f8;
  text-align: left;
  border-radius: 5px;

  @media (max-width: 768px) {
    text-align: center;
    align-items: center;

    p {
      display: flex;
      flex-direction: column;
      font-size: 14px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0rem;
  }

  a {
    color: #385963;
    text-decoration: underline;

    &:hover {
      color: #2c4a52;
    }
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.75);
  display: ${(props) => (props.visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 10000;
 
}
`;

const ModalContent = styled.div`
  width: 90vw;
  height: 90vh;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const PdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;


const PdfFileButtons = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction:column;
  flex-wrap: wrap;
a{
  &:hover {
    color: #007bff; /* Darker red on hover */
  }
}
  justify-content: left;
    @media (max-width: 768px) {
     font-size: 10px;
       justify-content:center;
  }

`;

const ProviderDetails = ({ provider }) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const tokenString = sessionStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [modalVisible, setModalVisible] = useState(false);
const [modalPdfUrl, setModalPdfUrl] = useState(null);


  const openModal = (url) => {
  setModalPdfUrl(url);
  setModalVisible(true);
};

const closeModal = () => {
  setModalVisible(false);
  setModalPdfUrl(null);
};

  useEffect(() => {
    const fetchFiles = async () => {
      const fileNames = provider?.providerProfile?.fileNames || [];

      if (fileNames.length === 0) {
        setFiles([]);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${BASE_URL}ProviderProfile/getFiles`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenString}`
          },
          body: JSON.stringify(fileNames)
        });

        if (!response.ok) throw new Error("Failed to fetch file contents");

        const fileData = await response.json();
        const decodedFiles = fileData.map(f => ({
          id: f.fileName,
          name: f.originalFileName || f.fileName || "Unnamed.pdf",
          url: `data:${f.mimeType};base64,${f.base64Content}`
        }));

        setFiles(decodedFiles);
      } catch (err) {
        console.error("Error fetching file contents:", err);
        setFiles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, [provider, BASE_URL, tokenString]);

  
  return (
    <DetailsContainer>
      <p><strong>{t('fullname')}:</strong> {provider.name}</p>
      <p><strong>{t('email')}:</strong> {provider.email}</p>
      <p><strong>{t('phone')}:</strong> {provider?.providerProfile?.phoneNumber || t('notAvailable')}</p>
      <p><strong>{t('files')}:</strong></p>
      {loading ? (
        <p>{t('loading')}...</p>
      ) : files.length > 0 ? (
        <ul>
           <PdfFileButtons>
                       {files.map((file) => (
                         <a
                           key={file.id}
                           href="#!"
                           onClick={(e) => {
                             e.preventDefault();
                             openModal(file.url);
                           }}
                           style={{
                             marginRight: "10px",
                             marginTop: "10px",
                             cursor: "pointer",
                            //  color: selectedPdfUrl === file.url ? "#4CAF50" : "#385963",
                             textDecoration: "underline",
                             display: "inline-block",
                           }}
                         >
                           {file.name}
                         </a>
                       ))}
                     </PdfFileButtons>
        </ul>
      ) : (
        <p>{t('noFilesAvailable')}</p>
      )}


    <ModalOverlay visible={modalVisible} onClick={closeModal}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <PdfIframe src={modalPdfUrl} title="PDF Fullscreen Preview" />
      </ModalContent>
    </ModalOverlay>
    </DetailsContainer>
  );
};

export default ProviderDetails;
